'use strict';
/*!
 * Department search.
 *
 * @deps jquery
 */

const $ = jQuery;

/**
 * Reset display with no campus selected.
 */
const resetDisplay = function () {
	$( '.js-result-parts' ).attr( 'aria-hidden', 'true' );
	$( '.js-select-parts' ).attr( 'aria-hidden', 'false' );
	$( '.js-result-text' ).attr( 'aria-hidden', 'true' );
	$( '.campus-container-js' ).attr( 'aria-hidden', 'false' );
	setTimeout( () => {
		$( 'html,body' ).scrollTop( 0 );
	}, 1 );
};

/**
 * Display target text "○○キャンパスにある学部はこちら"
 *
 * @param {string} target Target to display.
 */
const displayText = function ( target ) {
	$( '.js-result-text' ).each( function ( index, text ) {
		const id = $( text ).attr( 'id' );
		$( text ).attr( 'aria-hidden', ( id === `${target}-text` ) ? 'false': 'true' );
	} );
};

// Toggle JS.
const toggleController = function () {
	$( '.js-result-parts' ).attr( 'aria-hidden', 'false' );
	$( '.js-select-parts' ).attr( 'aria-hidden', 'true' );
};

/**
 * Display selected campus and scroll window.
 *
 * @param {string} target ID of campus.
 */
const campusChosen = function ( target ) {
	target = target.replace( /^#/, '' );
	// Display container.
	$( '.campus-container-js' ).each( function ( index, container ) {
		const id = $( container ).attr( 'id' );
		$( container ).attr( 'aria-hidden', ( id === target ) ? 'false': 'true' );
	} );
	// Display text.
	displayText( target );
	// Toggle controller.
	toggleController();
	// Move back.
	setTimeout( () => {
		$( 'body,html' ).stop();
		$( 'html,body' ).scrollTop( $( '.wp-block-tokai-select-ug__result-description' ).offset().top - 150 );
	}, 1 );
};

// Reset display.
$( '#js-search-reset' ).click( function () {
	if ( window.location.hash ) {
		window.location.hash = '';
	}
} );

// Move header location if original location has hash.
const hash = window.location.hash;
if ( hash.length ) {
	$( 'body,html' ).stop().scrollTop( 0 );
}
$( document ).ready( () => {
	const $link = $( `a[href="${hash}"]` );
	if ( hash.length > 3 && $link.length ) {
		campusChosen( hash );
	}
} );

// Listen hash change.
$( window ).on( 'hashchange', function ( e ) {
	const hash = window.location.hash;
	if ( hash.length > 3 && $( `a[href="${hash}"]` ).length ) {
		campusChosen( hash );
	} else {
		resetDisplay();
	}
} );
